// src/components/forms/pending-orders/PendingOrdersProductsSection.tsx
// Componente para la sección de Productos del Pedido

import React from 'react'
import OrderItemsTable from '../../tables/OrderItemsTable'
import SectionTitle from '../../ui/SectionTitle'
import { ShoppingBagIcon } from '@heroicons/react/24/outline'
import type { OrderDetail } from '../../../types/pendingOrdersFormTypes'

interface PendingOrdersProductsSectionProps {
  orderDetail?: OrderDetail | null
  hideProductSection: boolean
  /** Refleja extraDetails del pedido (sin control visible en UI) */
  clienteNeto: boolean
  productDetails: { [key: string]: any }
  loadingDetails: { [key: string]: boolean }
  expandedCombos: { [key: string]: boolean }
  onToggleCombo: (productId: string) => void
  calculateTotals: (items: any[]) => { subtotal: string; discount: string; taxes: string; shipping: string; total: string }
}

export const PendingOrdersProductsSection: React.FC<PendingOrdersProductsSectionProps> = ({
  orderDetail,
  hideProductSection,
  clienteNeto,
  productDetails,
  loadingDetails,
  expandedCombos,
  onToggleCombo,
  calculateTotals
}) => {
  if (hideProductSection) return null

  return (
    <div className="bg-white rounded-lg shadow-sm p-6">
      <SectionTitle icon={ShoppingBagIcon}>Productos del Pedido</SectionTitle>

      <OrderItemsTable
        lineItems={orderDetail?.lineItems || []}
        productDetails={productDetails}
        loadingDetails={loadingDetails}
        expandedCombos={expandedCombos}
        mode="view"
        formDataStatus={orderDetail?.status}
        onQuantityChange={() => {
          console.log('Cambio de cantidad no permitido en modo view')
        }}
        onRemoveProduct={() => {
          console.log('Eliminación no permitida en modo view')
        }}
        onDiscountChange={() => {
          console.log('Cambio de descuento no permitido en modo view')
        }}
        onPriceChange={() => {
          console.log('Cambio de precio no permitido en modo view')
        }}
        onToggleCombo={onToggleCombo}
        calculateTotals={calculateTotals}
        shippingCost={orderDetail?.envio || '0'}
        clienteNeto={clienteNeto}
      />
    </div>
  )
}
